export const theme = {
    grey_1: '#2b2b2b',
    white_1: '#ffffff',
    purple_1: '#5d0b71',
    purple_2: '#89178f',
    purple_3: '#b861d8',
    transparent: 'transparent',
};
